import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=2227a508"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2227a508')) {
      api.createRecord('2227a508', component.options)
    } else {
      api.reload('2227a508', component.options)
    }
    module.hot.accept("./serviceFee.vue?vue&type=template&id=2227a508", function () {
      api.rerender('2227a508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/serviceFee.vue"
export default component.exports